import { Iframe } from "./Iframe";
import { Tab } from "./sample/Tab";

export const FlexdeskBookings = () => {
  return (
    <Tab>
      <Iframe url="bookings-flexdesk-employee" />
    </Tab>
  );
};
